import React, { useEffect } from 'react';
import { GetServerSideProps } from "next";
import { useDecision } from '@optimizely/react-sdk';
import { useRouter } from 'next/router';

import Page from '@noqo/clients/web/Page';
import initializePage from "@/common/pageSetup";
import Routes from '@/router/routes';

type Props = {
    optimizelyData: {
        datafile: Record<string, unknown>;
        optimizelyUserId: string;
    };
};

const Bundle = ({ optimizelyData }: Props): JSX.Element => {
    const router = useRouter();
    const [{ enabled: isNoqoDealsEnabled }] = useDecision('fr-noqo-86-deals-enabled-2');

    useEffect(() => {
        const hasValidOptimizelyData = optimizelyData?.datafile &&
            optimizelyData?.optimizelyUserId &&
            Object.keys(optimizelyData.datafile).length > 0;

        if (hasValidOptimizelyData && !isNoqoDealsEnabled) {
            const { bundleCode } = router.query;
            router.replace({
                pathname: Routes.DEALS,
                query: { id: bundleCode }
            });
        }
    }, [isNoqoDealsEnabled, optimizelyData, router]);

    return <Page slug="deals/deal" />
}

export const getServerSideProps: GetServerSideProps = async (ctx) => initializePage(ctx, 'bundle-builder');

export default Bundle;